import { config } from "../config";

export type PrinterAsset = {
    printerTechnology: string;
    printerModel: string;
    imageUri: string;
};

const DEFAULT_IMAGE = `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/default.png`;

// Deduplicated and optimized printer array for image resolution
// Prioritizes short model names (as used by Zeus API) and removes near-duplicates
export const printers: PrinterAsset[] = [
    // SAF printers
    {
        printerTechnology: "SAF",
        printerModel: "Stratasys H350",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/PBF_H350.png`,
    },
    {
        printerTechnology: "SAF",
        printerModel: "PBF",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/PBF_H350.png`,
    },
    {
        printerTechnology: "SAF",
        printerModel: "H350",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/PBF_H350.png`,
    },

    // Polyjet - J55 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "J55",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j55.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "J55_0009",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j55.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "PolyJet",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j55.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Pj",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j55.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J55 Dental",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j55_dental.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J55 Prime",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j55.png`,
    },

    // Polyjet - J5 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "J5 DentaJet",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J5 Digital Anatomy",
        imageUri: DEFAULT_IMAGE,
    },

    // Polyjet - J3 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "J3 DentaJet",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J3 DentaJet",
        imageUri: DEFAULT_IMAGE,
    },

    // Polyjet - J35 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "J35",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "J35 Pro",
        imageUri: DEFAULT_IMAGE,
    },

    // Polyjet - J750 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "J750",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/Polyjet_J750.png`,
    },

    // Polyjet - J826 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J826",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/pj_j826.png`,
    },

    // Polyjet - J850 Series
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J850",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/PolyJet_J850.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J850 Prime",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/PolyJet_J850.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys J850 Digital Anatomy",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/Polyjet_J750.png`,
    },

    // Polyjet - Other
    {
        printerTechnology: "Polyjet",
        printerModel: "Objet500 Connex3",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/Polyjet_Objet500_Connex3.png`,
    },
    {
        printerTechnology: "Polyjet",
        printerModel: "Stratasys Arbel Pro",
        imageUri: DEFAULT_IMAGE,
    },

    // FDM - F series
    {
        printerTechnology: "FDM",
        printerModel: "Stratasys F170",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/FDM_F170.png`,
    },
    {
        printerTechnology: "FDM",
        printerModel: "Stratasys F370",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/FDM_F370.png`,
    },
    {
        printerTechnology: "FDM",
        printerModel: "Stratasys F370 CR",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "FDM",
        printerModel: "Stratasys F770",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/FDM_F770.png`,
    },
    {
        printerTechnology: "FDM",
        printerModel: "Stratasys F900",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/FDM_F900.png`,
    },
    {
        printerTechnology: "FDM",
        printerModel: "Stratasys F3300",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "FDM",
        printerModel: "FDM F3300",
        imageUri: DEFAULT_IMAGE,
    },

    // FDM - Fortus series
    {
        printerTechnology: "FDM",
        printerModel: "Fortus 450mc",
        imageUri: `${config.REACT_APP_PRINTER_IMAGE_BASE_URL}/FDM_Fortus_450mc.png`,
    },

    // Unknown technology
    {
        printerTechnology: "Unknown",
        printerModel: "Stratasys Origin One",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Unknown",
        printerModel: "Stratasys Origin One+",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Unknown",
        printerModel: "Stratasys Origin Two",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Unknown",
        printerModel: "Stratasys Neo450s",
        imageUri: DEFAULT_IMAGE,
    },
    {
        printerTechnology: "Unknown",
        printerModel: "Stratasys Neo800",
        imageUri: DEFAULT_IMAGE,
    },
];

/**
 * Gets the image URI for a printer model.
 * This function prioritizes exact matches first, then searches for partial matches
 * to handle both short names (like "J55") and full names (like "Stratasys J55 Dental").
 *
 * @param printerModel - The printer model name from the API
 * @returns The image URI for the printer, or default.png if not found
 */
export const getPrinterImage = (printerModel?: string): string => {
    if (!printerModel) {
        return DEFAULT_IMAGE;
    }

    const normalizedInput = printerModel.toLowerCase().trim();
    const normalizedPrinters = printers.map((printer, index) => ({
        printer,
        index,
        normalizedModel: printer.printerModel.toLowerCase().trim(),
    }));

    // First, try exact match
    let match = normalizedPrinters.find(
        ({ normalizedModel }) => normalizedModel === normalizedInput
    )?.printer;

    if (match) {
        return match.imageUri;
    }

    // Then prefer the most specific known model contained within a longer API-provided name.
    const containingMatches = normalizedPrinters
        .filter(({ normalizedModel }) => normalizedInput.includes(normalizedModel))
        .sort(
            (left, right) =>
                right.normalizedModel.length - left.normalizedModel.length ||
                left.index - right.index
        );

    match = containingMatches[0]?.printer;

    if (match) {
        return match.imageUri;
    }

    // Then try matching short codes (e.g., "J55" should match "Stratasys J55 Dental")
    // Split the input and search for entries that contain all the parts
    const inputParts = normalizedInput.split(/\s+/).filter((part) => part.length > 0);

    // If input is a short code, search for it as a substring in printer models
    if (inputParts.length === 1) {
        match = normalizedPrinters.find(({ normalizedModel }) =>
            normalizedModel.includes(normalizedInput)
        )?.printer;
        if (match) {
            return match.imageUri;
        }
    }

    return DEFAULT_IMAGE;
};
